import { Box, Button, makeStyles, Theme, Typography } from '@material-ui/core';
import React from 'react';

import { FormSection } from '../../../../shared/forms/FormSection';

type Props = {
  mode: 'create' | 'update';
  onPlexDelete: () => void;
};

export const DeletePlex = React.memo((props: Props): React.ReactElement | null => {
  const { mode, onPlexDelete } = props;
  const classes = useStyles();

  if (mode !== 'update') {
    return null;
  }

  return (
    <FormSection title="Danger zone">
      <Box className={classes.sectionRow}>
        <Box>
          <Typography variant="subtitle2" gutterBottom>
            Delete this plex along with all its content.
          </Typography>
          <Typography>Once you delete a plex, there is no going back.</Typography>
        </Box>
        <Box className={classes.sectionRowButton}>
          <Button variant="outlined" color="secondary" onClick={onPlexDelete}>
            Delete plex
          </Button>
        </Box>
      </Box>
    </FormSection>
  );
});

const useStyles = makeStyles((theme: Theme) => ({
  sectionRow: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  sectionRowButton: {
    minWidth: 'fit-content',
  },
}));
